import { sendApiClientRequest } from "../../api/api";

const BASE = "/api/website-release-notes";

const unwrap = (res) => {
  if (!res || res.status >= 400) {
    const msg = res?.data?.msg ?? "請求失敗";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }

  const body = res.data;
  if (!body || typeof body !== "object") {
    return null;
  }
  if (body.error) {
    const msg = body.msg ?? "錯誤";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return body.data !== undefined ? body.data : null;
};

export const fetchReleaseNotesList = async ({
  search = "",
  page = 1,
  limit = 15,
  is_published,
  is_draft,
} = {}) => {
  const params = new URLSearchParams();

  if (typeof search === "string" && search.trim()) {
    params.set("search", search.trim());
  }

  if (typeof is_published === "boolean") {
    params.set("is_published", String(is_published));
  }

  if (typeof is_draft === "boolean") {
    params.set("is_draft", String(is_draft));
  }

  params.set("page", String(page));
  params.set("limit", String(limit));

  const res = await sendApiClientRequest("GET", `${BASE}?${params.toString()}`);
  return unwrap(res);
};

export const fetchReleaseNoteById = async (id) => {
  const res = await sendApiClientRequest("GET", `${BASE}/${id}`);
  return unwrap(res);
};

export const createReleaseNote = async (payload) => {
  const res = await sendApiClientRequest("POST", BASE, payload);
  return unwrap(res);
};

export const createReleaseNoteMultipart = async (formData) => {
  const res = await sendApiClientRequest("POST", BASE, formData, true);
  return unwrap(res);
};

export const updateReleaseNote = async (id, payload) => {
  const res = await sendApiClientRequest("PATCH", `${BASE}/${id}`, payload);
  return unwrap(res);
};

export const updateReleaseNoteMultipart = async (id, formData) => {
  if (formData instanceof FormData) {
    formData.append("_method", "PATCH");
  }
  const res = await sendApiClientRequest(
    "POST",
    `${BASE}/${id}`,
    formData,
    true,
  );
  return unwrap(res);
};

export const deleteReleaseNote = async (id) => {
  const res = await sendApiClientRequest("DELETE", `${BASE}/${id}`);
  return unwrap(res);
};

export const patchReleaseNotePublish = async (id, { is_published }) => {
  const res = await sendApiClientRequest(
    "PATCH",
    `${BASE}/${id}/publish`,
    { is_published },
  );
  return unwrap(res);
};

